import React from 'react';
import PropTypes from 'prop-types';
import { getModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import HouseholdInfoFlyout from 'Components/Flyouts/HouseholdInfo';
import Household from 'Components/Flyouts/Household';
import FileViewerModal from 'Components/Modals/FileViewer';
import RemindersDialog from 'Components/Modals/RemindersDialog';
import UncategorizedMeetingModal from 'Components/Modals/UncategorizedMeetingModal';
import BulkCommunicationDialog from 'Components/Modals/BulkCommunicationDialog';
import BulkCommunicationSummaryDialog from 'Components/Modals/BulkCommunicationSummary';
import ClientSchedulerModal from 'Components/Modals/ClientSchedulerModal';
import InvoiceReceiptsModal from 'Components/Modals/InvoiceReceiptsModal/invoiceReceipts';
import {
  AgentInvoiceReceiptModal,
  ClientInvoiceReceiptModal,
} from 'Components/Modals/InvoiceReceiptsModal/invoiceReceipt';
import InstantBookerModal from 'Components/Modals/InstantBookerModal';
import SimpleActionItemGroupModal from 'Components/Modals/SimpleActionItemGroupModal';
import TrustApprovalModal from 'Components/Modals/TrustApproval';
import AdvisorNoteModal from '../AdvisorNoteModal';
import AdvisorNoteLinkModal from '../AdvisorNoteLinkModal';
import CreateHousehold from '../CreateHousehold';
import LogCallModal from '../LogCallModal';
import ManagedAccountsModal from '../ManagedAccounts';
import ClientActionItemModal from '../ClientActionItemModal';
import RealAssetModal from '../RealAssetModal';
import EmergencyFundModal from '../EmergencyFundModal';
import HistoryFlyout from '../HistoryFlyout';
import GoalModal from '../GoalModal';
import TasksAndTodosModal from '../TasksAndTodos';
import GoalActionItemModal from '../GoalActionItemModal';
import TimelineNewEventDialog from '../TimelineNewEventDialog';
import SimpleActionItemModal from '../SimpleActionItemModal';
import SimpleActionItemLinkModal from '../SimpleActionItemLinkModal';
import TaskModal from '../TaskModal';
import FinancialWellnessScoreDialog from '../FinancialWellnessScoreDialog';
import PlaybooksModal from '../PlaybooksModal';
import DependentModal from '../DependentModal';
import ClientMeetingPreview from '../ClientMeetingPreview';
import MCSchedulerModal from '../MCSchedulerModal';
import OutOfOfficeModal from '../OutOfOffice';
// DO NOT REMOVE - GENERATOR REPLACE ME - MODAL IMPORTS

const modals = {
  Advisor: {
    [modalConsts.advisorNote]: AdvisorNoteModal,
    [modalConsts.advisorNoteLinkModal]: AdvisorNoteLinkModal,
    [modalConsts.createHousehold]: CreateHousehold,
    [modalConsts.logCall]: LogCallModal,
    [modalConsts.fileViewer]: FileViewerModal,
    [modalConsts.managedAccounts]: ManagedAccountsModal,
    [modalConsts.householdInfo]: HouseholdInfoFlyout,
    [modalConsts.household]: Household,
    [modalConsts.goalModal]: GoalModal,
    [modalConsts.emergencyFundModal]: EmergencyFundModal,
    [modalConsts.realAssetModal]: RealAssetModal,
    [modalConsts.historyFlyout]: HistoryFlyout,
    [modalConsts.tasksAndTodos]: TasksAndTodosModal,
    [modalConsts.timelineNewEventDialog]: TimelineNewEventDialog,
    [modalConsts.simpleActionItemModal]: SimpleActionItemModal,
    [modalConsts.simpleActionItemGroupModal]: SimpleActionItemGroupModal,
    [modalConsts.simpleActionItemLinkModal]: SimpleActionItemLinkModal,
    [modalConsts.taskModal]: TaskModal,
    [modalConsts.playbooksModal]: PlaybooksModal,
    [modalConsts.dependentsModal]: DependentModal,
    [modalConsts.clientMeetingPreview]: ClientMeetingPreview,
    [modalConsts.mcScheduler]: MCSchedulerModal,
    [modalConsts.remindersDialog]: RemindersDialog,
    [modalConsts.uncategorizedMeetingModal]: UncategorizedMeetingModal,
    [modalConsts.bulkCommunication]: BulkCommunicationDialog,
    [modalConsts.bulkCommunicationSummary]: BulkCommunicationSummaryDialog,
    [modalConsts.outOfOfficeModal]: OutOfOfficeModal,
    [modalConsts.instantBookerModal]: InstantBookerModal,
    [modalConsts.invoiceReceiptsModal]: InvoiceReceiptsModal,
    [modalConsts.trustApproval]: TrustApprovalModal,
    [modalConsts.invoiceReceiptModal]: AgentInvoiceReceiptModal,
    // DO NOT REMOVE - GENERATOR REPLACE ME - MODAL DICTIONARY
  },
  Client: {
    [modalConsts.fileViewer]: FileViewerModal,
    [modalConsts.managedAccounts]: ManagedAccountsModal,
    [modalConsts.clientActionItemModal]: ClientActionItemModal,
    [modalConsts.simpleActionItemLinkModal]: SimpleActionItemLinkModal,
    [modalConsts.emergencyFundModal]: EmergencyFundModal,
    [modalConsts.realAssetModal]: RealAssetModal,
    [modalConsts.goalActionItemModal]: GoalActionItemModal,
    [modalConsts.financialWellnessScoreModal]: FinancialWellnessScoreDialog,
    [modalConsts.clientMeetingPreview]: ClientMeetingPreview,
    [modalConsts.clientSchedulerModal]: ClientSchedulerModal,
    [modalConsts.invoiceReceiptsModal]: InvoiceReceiptsModal,
    [modalConsts.invoiceReceiptModal]: ClientInvoiceReceiptModal,
    [modalConsts.trustApproval]: TrustApprovalModal,
    // DO NOT REMOVE - GENERATOR REPLACE ME - MODAL DICTIONARY
  },
};

function ModalRouter({ modalScope }) {
  const modalSet = modals[modalScope];
  if (!modalSet) {
    return null;
  }

  const { modalName, modalData } = getModal();

  const Modal = modalSet[modalName];
  if (!Modal) {
    return null;
  }
  let modalProps = {};

  if (modalData) {
    modalProps = JSON.parse(atob(modalData));
  }

  return <Modal {...modalProps} />;
}

ModalRouter.propTypes = {
  modalScope: PropTypes.oneOf(['App', 'Advisor', 'Client']),
};

ModalRouter.defaultProps = {
  modalScope: 'App',
};

export default ModalRouter;
